/* SEO For ALL theme — scripts */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {} };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = (format || T.moneyFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    function fmt(n, dec, th, decSep) {
      dec = dec == null ? 2 : dec; th = th || ','; decSep = decSep || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return whole + (parts[1] ? decSep + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.themeFormatMoney = formatMoney;

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.querySelector('[data-toast-message]').textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  function updateCartCount() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!T.cartAjax || !form.matches('form[action*="/cart/add"]')) return;
    if (!form.checkValidity()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-form-message]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (msg) msg.hidden = true;
    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || T.strings.error);
        toast((res.data.product_title || '') + ' · ' + T.strings.added);
        return updateCartCount();
      })
      .catch(function (err) {
        if (msg) { msg.textContent = err.message || T.strings.error; msg.hidden = false; }
        else toast(err.message || T.strings.error);
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); if (!btn.hasAttribute('data-unavailable-now')) btn.disabled = false; }
      });
  });

  /* Product page */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var fieldsets = root.querySelectorAll('[data-option-index]');
    var btn = form.querySelector('[data-add-btn]');
    var priceEl = root.querySelector('[data-price]');
    var cmpEl = root.querySelector('[data-compare]');
    var gallery = root.querySelector('[data-gallery]');

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked') || fs.querySelector('select');
        return c ? c.value : null;
      });
    }

    function update() {
      var opts = selected();
      fieldsets.forEach(function (fs, i) {
        var s = fs.querySelector('[data-option-value]');
        if (s) s.textContent = opts[i];
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) {
        btn.disabled = true; btn.setAttribute('data-unavailable-now', '');
        btn.textContent = btn.dataset.unavailable; return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (cmpEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = formatMoney(v.compare_at_price); cmpEl.hidden = false; }
        else cmpEl.hidden = true;
      }
      if (v.available) { btn.disabled = false; btn.removeAttribute('data-unavailable-now'); btn.textContent = btn.dataset.add; }
      else { btn.disabled = true; btn.setAttribute('data-unavailable-now', ''); btn.textContent = btn.dataset.soldout; }
      if (v.featured_media && gallery) scrollToMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    function scrollToMedia(id) {
      var item = gallery.querySelector('[data-media-id="' + id + '"]');
      if (!item) return;
      gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.thumb == id ? 'true' : 'false');
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { scrollToMedia(t.dataset.thumb); });
    });
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
        input.value = n;
      });
    });
  }
  document.querySelectorAll('[data-product]').forEach(initProduct);

  /* Slideshow */
  document.querySelectorAll('[data-slideshow]').forEach(function (s) {
    var track = s.querySelector('.slides');
    var n = track ? track.children.length : 0;
    if (n < 2) return;
    var dots = s.querySelector('.slideshow__dots');
    var i = 0, timer;
    dots.innerHTML = Array.apply(null, Array(n)).map(function (_, k) {
      return '<button type="button" aria-label="Slide ' + (k + 1) + '" aria-current="' + (k === 0) + '"></button>';
    }).join('');
    function set(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      Array.prototype.forEach.call(dots.children, function (d, j) { d.setAttribute('aria-current', j === i); });
    }
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) { set(Array.prototype.indexOf.call(dots.children, b)); restart(); }
    });
    function restart() {
      clearInterval(timer);
      var speed = parseInt(s.dataset.speed, 10) || 0;
      if (speed && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { set(i + 1); }, speed * 1000);
    }
    restart();
  });

  /* Close menus on outside click / Escape */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-closable][open]').forEach(function (d) {
      if (!d.contains(e.target) || e.target.closest('[data-close]')) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('details[data-closable][open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* Collection filters: submit on change */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      form.submit();
    });
  });

  /* Cart: update on quantity change */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[name="updates[]"]')) form.submit();
    });
  });

  /* Product recommendations */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          var wrap = el.closest('section');
          if (wrap) wrap.hidden = false;
        }
      })
      .catch(function () {});
  });
})();
